import { User } from "../interfaces/user";
import { EditCategoryRedux, categoryReducer } from "./category_reducer";
import { EditMenuRedux, menuReducer } from "./menu_reducer";
import { OrderRedux, orderReducer } from "./order_reducer";
import { userReducer } from "./user_reducer";
import { Reducer, combineReducers } from "redux";

export interface State {
  user: User;
  order: OrderRedux;
  menu: EditMenuRedux;
  category : EditCategoryRedux;
}

const rootreducer: Reducer<State> = combineReducers({
  user: userReducer,
  order: orderReducer,
  menu: menuReducer,
  category: categoryReducer
});

export default rootreducer;